module.exports = __webpack_public_path__ + "img/popup_button4_normal.b6ef6680.png";